import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./SectionPage.module.css";
import { REACT_APP_API_URL } from "../../env";
import axios from "axios";

function SectionPage() {
  const { sectionKey } = useParams();
  const [pdfs, setPdfs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}/api/dashboard/admin/list-all-media?type=${sectionKey}`
        );
        console.log("response", response);
        setPdfs(response.data.data || []);
      } catch (err) {
        console.error("Error fetching PDFs:", err);
      }
    };

    fetchData();
  }, [sectionKey]);

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerText}>{sectionKey.toUpperCase()}</div>
      </div>

      <div className={styles.pdfGrid}>
        {pdfs.map((pdf) => (
          <div key={pdf.intMediaId} className={styles.pdfCard}>
            {pdf.vchThumbnailPath && (
              <img
                src={`${REACT_APP_API_URL}/${pdf.vchThumbnailPath.replace(
                  /\\/g,
                  "/"
                )}`}
                alt={pdf.vchDescription}
                className={styles.thumbnail}
              />
            )}

            <h3>{pdf.vchDescription}</h3>

            <a
              href={`${REACT_APP_API_URL}/${pdf.vchFilePath.replace(
                /\\/g,
                "/"
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View PDF
            </a>

            {/* Optional: Date */}
            <p className={styles.date}>
              {new Date(pdf.dtmCreatedOn).toLocaleDateString('en-IN')}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SectionPage;
